import axios from "axios";
import {
    PublicTransportBookingReadDto,
    UpdateMyTransportBookingDto,
} from "../types/transportPublicTypes";

const apiUrl = process.env.REACT_APP_API_URL as string;

export async function getMyTransportBookings(
    userId: number,
    eventId: number
) {
    const res = await axios.get<PublicTransportBookingReadDto[]>(
        `${apiUrl}/api/events/${eventId}/transport/users/${userId}/my-bookings`
    );
    return res.data;
}

export async function updateMyTransportBooking(
    eventId: number,
    userId: number,
    requestId: number,
    dto: UpdateMyTransportBookingDto
) {
    const res = await axios.patch(
        `${apiUrl}/api/events/${eventId}/transport/users/${userId}/my-bookings/${requestId}`,
        dto
    );
    return res.data;
}